import { Box, Typography } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import React from "react";
import { IUploads } from "../interface/iUploads";
import { ParticipantFilesContext } from "../context/participantFilesContext";

const NoEditableFileMessage = (): React.JSX.Element => {
  const {
    uploads,
  }: {
    uploads: IUploads;
  } = React.useContext(ParticipantFilesContext);

  return (
    <React.Fragment>
      {!uploads.editableFile && (
        <Box
          sx={{
            textAlign: "center",
            background: (theme) => theme.palette.error.main,
            borderRadius: 2,
            padding: 2,
            mb: 2,
            color: (theme) => theme.palette.error.contrastText,
          }}
        >
          <Typography
            variant="h5"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
              mb: 2,
            }}
          >
            <ReportProblemOutlinedIcon
              sx={{
                fontSize: 40,
                color: (theme) => theme.palette.error.contrastText,
              }}
            />
            Achtung! Bisher hast Du noch keine editierbare Datei hochgeladen.
            <ReportProblemOutlinedIcon
              sx={{
                fontSize: 40,
                color: (theme) => theme.palette.error.contrastText,
              }}
            />
          </Typography>

          <Typography variant="body1" component="div" sx={{ mb: 2 }}>
            Erst wenn du unter „Meine Unterlagen“ mindestens eine editierbare
            Datei hochgeladen hast (Word-Dokument), werden die Buchungsbutton
            freigeschaltet.
          </Typography>
        </Box>
      )}
    </React.Fragment>
  );
};

export default NoEditableFileMessage;
